const ADD_LINK_BUTTON = "LinkButton";

export { ADD_LINK_BUTTON };
//# sourceMappingURL=dataHooks.js.map
